import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("UI ErrorBoundary caught:", error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.assign("/");
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="error-boundary"
          className="min-h-screen flex flex-col items-center justify-center bg-[var(--ha-ivory)] px-6 text-center"
        >
          <p className="font-mono-label text-[10px] uppercase tracking-[0.3em] text-[var(--ha-gold-deep)] mb-6">
            ◐ Something diffused incorrectly
          </p>
          <h1 className="font-serif-display text-4xl sm:text-5xl text-[var(--ha-maroon)] leading-tight mb-6">
            A note went off-balance.
          </h1>
          <p className="text-stone-600 max-w-md mb-10">
            An unexpected error occurred while composing this page. Please return to the atelier and try again.
          </p>
          <button
            data-testid="error-boundary-home-btn"
            onClick={this.handleReload}
            className="px-10 py-4 border border-[var(--ha-maroon)] bg-[var(--ha-maroon)] text-[var(--ha-cream)] font-mono-label text-xs uppercase tracking-[0.25em] hover:bg-[var(--ha-gold-deep)] hover:border-[var(--ha-gold-deep)] transition-colors"
          >
            Back to the Atelier
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
